module.exports = __webpack_public_path__ + "281e71162d336aaa4783b5eb5b4c5aa4.fbx";